export default {
    dramaReview: {
        drama: {
            info: 'Drama Info',
            title: 'Drama Title',
            creatorInfo: 'Creator Info',
            creatorUid: 'Creator UID',
            createdAt: 'Created At',
            onlineAt: 'Online At',
            offlineAt: 'Offline At',
            userId: 'Creator UID',
            cover: 'Cover',
            preview: 'Preview Video',
            description: 'Description',
        },
        episode: {
            section: 'Episodes',
            no: 'No.',
            title: 'Episode Title',
            duration: 'Duration',
            playCount: 'Plays',
            status: 'Status',
            video: 'Video',
            empty: 'No episodes',
        },
        auditStatus: 'Audit Status',
        dramaStatus: 'Drama Status',
        adminReviewStatus: {
            label: 'Admin Review Status',
            Pending_FIRST_PUBLISH: 'Pending · First Publish',
            Pending_ACTIVE_EDIT: 'Pending · Active Edit',
            Pending_PASSIVE_EDIT: 'Pending · Passive Edit',
            Approved: 'Approved',
            Rejected: 'Rejected',
            Offline: 'Offline',
            Pending: 'Pending',
            unknown: 'Unknown',
        },
        badge: {
            label: 'Badge',
            none: 'None',
            setup: 'Set Badge',
            confirm: 'Confirm badge change?',
            OFFICIAL: 'Official',
            PARTNER: 'Partner',
            VERIFIED: 'Verified',
            COMMUNITY: 'Community',
            updateFailed: 'Failed to update badge',
            option: {
                drama: {
                    OFFICIAL: 'Official Drama',
                    PARTNER: 'Partner Drama',
                    VERIFIED: 'Verified Creator Drama',
                    COMMUNITY: 'Community Drama',
                },
            },
        },
        sort: {
            label: 'Sort',
            direction: 'Direction',
            created_at: 'Created At',
            updated_at: 'Updated At',
            online_at: 'Online At',
            asc: 'Ascending',
            desc: 'Descending',
        },
        reviewedStatus: 'Last Review Status',
        publishedStatus: 'Last Review Status',
        auditReason: 'Audit Reason',
        auditRemark: 'Audit Remark',
        auditRemarkPlaceholder: 'Optional',
        reject: {
            action: 'Reject',
            reason: 'Reject Reason',
            reasonPlaceholder: 'Please enter reject reason',
            reasonRequired: 'Reject reason is required',
            submit: 'Confirm Reject',
        },
        approve: {
            action: 'Approve',
            reason: 'Audit Remark',
            reasonPlaceholder: 'Optional',
            submit: 'Confirm Approve',
        },
        offline: {
            action: 'Take Offline',
            reason: 'Offline Reason',
            reasonPlaceholder: 'Please enter offline reason',
            reasonRequired: 'Offline reason is required',
            reasonMax: 'Offline reason must be at most 200 characters',
            submit: 'Confirm Offline',
            confirm: 'Take drama "{title}" offline? It cannot be republished.',
        },
        history: {
            section: 'Operation History',
            action: 'History',
            empty: 'No operation history',
            time: 'Time',
            status: 'Status',
            reason: 'Reason',
            reviewerId: 'Operator',
            count: '{count}',
        },
        table: {
            actions: 'Actions',
        },
        search: {
            id: 'Drama ID',
            titleFuzzy: 'Drama Title',
            userId: 'Creator UID',
            onlineAtStart: 'Online start',
            onlineAtEnd: 'Online end',
        },
        status: {
            PENDING_REVIEW: 'Pending Review',
            REVIEW_REJECTED: 'Rejected',
            REVIEW_APPROVED: 'Approved',
            PENDING_ONLINE: 'Pending NFT Mint',
            ONLINE: 'Online',
            OFFLINE: 'Offline',
            DELETED: 'Deleted',
            unknown: 'Unknown',
        },
        confirmApproveDrama: 'Approve drama "{title}"?',
        confirmRejectDrama: 'Reject drama "{title}"?',
        confirmApproveActor: 'Approve actor "{name}"?',
        confirmRejectActor: 'Reject actor "{name}"?',
        export: {
            button: 'Export',
            success: 'Export queued. Check Downloads when ready.',
        },
        heatCoefficient: {
            label: 'Heat Coefficient',
            updatedAt: 'Last Updated',
            edit: 'Edit',
            submit: 'Save',
            placeholder: 'Enter heat coefficient',
            required: 'Heat coefficient is required',
            range: 'Must be between {min} and {max}, up to 2 decimal places',
            decimals: 'At most 2 decimal places allowed',
            hint: 'Multiplier applied to raw heat. Historical heat is recalculated asynchronously after saving; refresh the list to see updates.',
            updateFailed: 'Failed to update heat coefficient',
            confirmTitle: 'Set Heat Coefficient · {title}',
        },
    },
};
